import i18n from '@/i18n'
import BlankLayout from '../../layout/blankLayout'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Index from './index'
import List from './list'
import AmbassadorList from './ambassadorList.vue'
import AmbassadorEdit from './ambassadorEdit.vue'
import Layout from '../layout.vue'

const basePath = '/v-admin/job-poster-management'
const ambassadorBasePath = '/v-admin/job-poster-ambassador'

const routes = [
  {
    name: 'jobPosterManagementList',
    path: `${basePath}/list`,
    component: List,
    meta: {
      isNewPage: true,
      breadcrumb: { hidden: true },
      get title () {
        return i18n.t('admin.company.jobPoster.title.jobPosterManagement')
      }
    }
  },
  {
    name: 'jobPosterManagementEdit',
    path: `${basePath}/edit/:posterType`,
    component: Index,
    meta: {
      isNewPage: true,
      get title () {
        return i18n.t('admin.company.jobPoster.title.jobPosterManagement')
      }
    }
  },
  {
    name: 'jobPosterAmbassadorManagement',
    path: `${ambassadorBasePath}`,
    component: BlankLayout,
    redirect: `${ambassadorBasePath}/list`,
    meta: {
      permission: ['PREMIUM_AMBASSADOR_POSTER'],
      isNewPage: true,
      get title () {
        return i18n.t('admin.company.jobPoster.title.jobPosterAmbassadorUpload')
      }
    },
    children: [
      {
        name: 'jobPosterAmbassadorList',
        path: `${ambassadorBasePath}/list`,
        component: AmbassadorList,
        meta: {
          permission: ['PREMIUM_AMBASSADOR_POSTER'],
          isNewPage: true,
          breadcrumb: { hidden: true },
          get title () {
            return i18n.t('admin.company.jobPoster.title.jobPosterAmbassadorUpload')
          }
        }
      },
      {
        path: `${ambassadorBasePath}/add`,
        component: AmbassadorEdit,
        meta: {
          permission: ['PREMIUM_AMBASSADOR_POSTER'],
          isNewPage: true,
          isEditMode: false,
          titleI18nKey: 'admin.company.jobPoster.title.jobPosterAmbassadorAdd'
        }
      },
      {
        path: `${ambassadorBasePath}/edit/:ambassadorId`,
        component: AmbassadorEdit,
        meta: {
          permission: ['PREMIUM_AMBASSADOR_POSTER'],
          isNewPage: true,
          isEditMode: true,
          titleI18nKey: 'admin.company.jobPoster.title.jobPosterAmbassadorEdit'
        }
      }
    ]
  }
]

export default {
  name: 'jobPosterManagementLayout',
  path: `${basePath}`,
  component: Layout,
  redirect: `${basePath}/list`,
  meta: {
    permission: ['PERM_JOB_POSTER_MANAGEMENT', 'PREMIUM_JOB_POSTER'],
    isAllInclude: true,
    isNewPage: true,
    get title () {
      return i18n.t('admin.company.jobPoster.title.jobPosterManagement')
    },
    menu: {
      get label () {
        return i18n.t('admin.company.jobPoster.title.jobPosterManagement')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
    }
  },
  children: routes
}
